// LivestreamDetailStreamLabel.js
import { connect } from 'react-redux';

import getPrivateShowStatus from '../selector/getPrivateShowStatus.js';
import getLiveStreamData from '../selector/getLiveStreamData.js';
import { getIsMeExclusivePrivateInviteInitiator } from '../selector/getLivestreamComputedData.js';
import getTimestampOffset, {
  Accuracy,
} from '../selector/getTimestampOffset.js';
import getGoalData from '../selector/getGoalData.js';
import { PRESET_SD } from '../resource/liveStreamConstants.js';
import LivestreamDetailStreamLabel from '../component/LivestreamDetailStreamLabel.jsx';

const mapStateToProps = (state, { streamId }) => {
  const currentExclusivePrivateGoalId = getLiveStreamData(
    state,
    [streamId, 'exclusivePrivate'],
    'currentId'
  );

  return {
    streamStatus: getLiveStreamData(state, [streamId], 'status'),
    privateShowStatus: getPrivateShowStatus(state, streamId),
    timestampOffsetSeconds: getTimestampOffset(state, Accuracy.SECOND),
    privateStreamCounterExp: getLiveStreamData(
      state,
      [streamId, 'presets', PRESET_SD, 'counter'],
      'exp'
    ),
    privateLiveStreamStartTimestamp: getLiveStreamData(
      state,
      [streamId, 'presets', PRESET_SD],
      'nbf'
    ),
    exclusivePrivateStatus: getLiveStreamData(
      state,
      [streamId, 'exclusivePrivate'],
      'status'
    ),
    countdownToExclusivePrivateNbf: getGoalData(
      state,
      [currentExclusivePrivateGoalId],
      'nbf'
    ),
    isMeExclusivePrivateInviteInitiator: getIsMeExclusivePrivateInviteInitiator(
      state,
      streamId
    ),
    consideringExclusivePrivateExp: getGoalData(
      state,
      [currentExclusivePrivateGoalId],
      'exp'
    ),
  };
};

export default connect(mapStateToProps)(LivestreamDetailStreamLabel);
